import { useEffect } from "react";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Capabilities from "@/components/landing/Capabilities";
import Portfolio from "@/components/landing/Portfolio";
import FrictionBar from "@/components/landing/FrictionBar";
import Positioning from "@/components/landing/Positioning";
import Services from "@/components/landing/Services";
import Industries from "@/components/landing/Industries";
import Testimonials from "@/components/landing/Testimonials";
import Insights from "@/components/landing/Insights";
import AuditForm from "@/components/landing/AuditForm";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  // Scroll to a hash target when arriving from another route (e.g. /#audit)
  useEffect(() => {
    const { hash } = window.location;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 60);
    }
  }, []);

  return (
    <main className="min-h-screen bg-[var(--yg-bg)] text-white" data-testid="landing-page">
      <Nav />
      <Hero />
      <Capabilities />
      <Portfolio />
      <FrictionBar />
      <Positioning />
      <Services />
      <Industries />
      <Testimonials />
      <Insights />
      <AuditForm />
      <Footer />
    </main>
  );
}
